import React from 'react';
import classNames from 'classnames';
import { LIST_STYLE_TYPES, SPACING } from './constants';

const List = ({ children, styleType = LIST_STYLE_TYPES.disc, spacing = SPACING.default }) => {
  const classes = classNames('ws-ui-list', `ws-ui-list--${styleType}`, `ws-ui-list--${spacing}`);
  return <ul className={classes}>{children}</ul>;
};

export default List;
